import { dispatchEvent } from '../helpers';

const createExperimentBody = (experimentId, variant) => ({
  experiment: { project: 'catalogo-v3', experimentId, variant: variant?.toUpperCase() },
});

export const experimentExposureEvent = ({ body }) => {
  if (typeof window !== 'undefined' && body?.id && body?.value) {
    dispatchEvent('experiment:exposure', createExperimentBody(body?.id, body?.value));
  }
};
